import { useMemo, useState } from 'react';
import language from '../../variables/language';

// Horizontal bar list: how many clients currently sit at each pipeline
// stage. Categorical color (each stage keeps its own already-established
// color from the pipeline module), direct-labeled so no legend is needed,
// only stages with at least one client are shown. A stage can belong to
// more than one pipeline (stagetype) - a small select scopes the list to
// one of them. The row list itself scrolls past a fixed height instead of
// growing the card, so the overview row stays a stable height regardless
// of how many stages a pipeline has.
export default function ClientsStageFunnel({ byStage }) {
   const [stagetypeId, setStagetypeId] = useState('');
   const lang = language[language.lang];

   const all = Array.isArray(byStage) ? byStage.filter(s => s.count > 0) : [];

   const stagetypes = useMemo(() => {
      const seen = new Map();
      all.forEach(s => {
         if (s.stagetypeId && !seen.has(s.stagetypeId)) {
            seen.set(s.stagetypeId, s.stagetypeName);
         }
      });
      return Array.from(seen, ([id, name]) => ({ id, name }));
   }, [all]);

   if (all.length === 0) {
      return '';
   }

   const stages = stagetypeId ? all.filter(s => String(s.stagetypeId) === String(stagetypeId)) : all;
   const max = Math.max(1, ...stages.map(s => s.count));

   return (
      <div className='clients-funnel-card'>
         <div className='clients-funnel-header'>
            <p className='clients-chart-title'>{lang.clientsPage.funnelTitle}</p>
            {stagetypes.length > 1 ? (
               <select className='clients-funnel-select' value={stagetypeId} onChange={(e) => setStagetypeId(e.target.value)}>
                  <option value=''>{lang.clientsPage.allStageTypes}</option>
                  {stagetypes.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
               </select>
            ) : ''}
         </div>
         <div className='clients-funnel'>
            {stages.map(stage => (
               <div className='clients-funnel-row' key={stage.id}>
                  <span className='clients-funnel-label'>{stage.name}</span>
                  <div className='clients-funnel-track'>
                     <div className='clients-funnel-bar' style={{width: (stage.count / max * 100) + '%', background: stage.color}}></div>
                  </div>
                  <span className='clients-funnel-value'>{stage.count}</span>
               </div>
            ))}
         </div>
      </div>
   )
}
